import { Typography } from "antd";
import { FormattedMessage } from "react-intl";
import classNames from "~utils/classNames";
import type { ScopeOption } from "./types/scopeOption";

import "./ScopeView.scss";

type Props = {
  scopeType: string | null | undefined;
  options: ScopeOption[];
};

const ScopeView = ({ scopeType, options }: Props) => {
  if (!scopeType) {
    return (
      <Typography.Paragraph className="all-access">
        <FormattedMessage id="permissions.user.role.viewAccess.allScope" />
      </Typography.Paragraph>
    );
  }

  return (
    <div className="permissions-scope-view">
      {options.map(({ value, label, data }) => (
        <div className={classNames("permissions-scope-view-item", data.length < 3 ? "is-compact-view" : "")} key={value}>
          <div className="permissions-scope-view-item-label-wrapper">{label}</div>
          <div className="permissions-scope-view-item-data-wrapper">
            {data
              .filter((item) => !!item.value)
              .map(({ label: dataLabel, value }) => (
                <Typography.Text key={value}>
                  <span className="permissions-scope-view-item-data-wrapper-label">{dataLabel}:</span>
                  <span>{value}</span>
                </Typography.Text>
              ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ScopeView;
